import { PersistedConfig } from "./types/theme.interface";

// breakPoints const
export const MIN_WIDTH_1400PX = '(min-width: 1400px)';
export const MAX_WIDTH_1399PX = '(max-width: 1399.98px)';
export const MIN_WIDTH_1025PX = '(min-width: 1025px)';
export const MAX_WIDTH_1024PX = '(max-width: 1024.98px)';
export const MIN_WIDTH_768PX = '(min-width: 768px)';
export const MAX_WIDTH_767PX = '(max-width: 767.98px)';

// layouts const
export const VERTICAL = 'vertical';

// DARK constants
export const LIGHT = 'light';
export const DARK = 'dark';

// Risk constants
export const HIGH_AMOUNT_THRESHOLD = 100_000;
export const HIGH_PERCENTAGE_THRESHOLD = 0.8;
export const MEDIUM_AMOUNT_THRESHOLD = 50_000;
export const MEDIUM_PERCENTAGE_THRESHOLD = 0.3;
export const HIGH_DAYS_THRESHOLD = 90;
export const MEDIUM_DAYS_THRESHOLD = 30;

export const PUBLIC_API_PATHS = ['/passwordReset', '/passwordForgot', '/login', '/passwordResetVerify', '/status'];
export const AUTH_EXCLUDED_PATHS = ['/passwordReset', '/passwordForgot', '/passwordResetVerify'];

// Default constants
export const DEFAULT_CONFIG: PersistedConfig = {
  layoutType: 'light',
  bodyColor: 'blue-theme',
}

export const STORAGE_KEY_COLUMNS = {
  STATEMENT: 'bindErp:statementVisibleCols',
  PRODUCTS: 'bindErp:productsVisibleCols',
};

export const STORAGE_KEY_CONFIG = 'bindErp:config';

export const MENU_ICON_MAP: Record<string, string> = {
  'Perfil de Usuario': 'account_circle',
  'Agregar Gasto': 'attach_money',
  'Timbrado de Nómina': 'receipt_long',
  'Inicio': 'home',
  'Dashboard': 'dashboard',
  'Compras': 'shopping_cart',
  'Producción': 'factory',
  'Inventarios': 'inventory',
  'Ventas': 'sell',
  'Finanzas': 'account_balance',
  'Contabilidad': 'request_quote',
  'Créditos': 'credit_card',
  'Reportes': 'analytics',
  'Configuración': 'settings',
  'Apps': 'apps',
  'Conviértete en Socio Nube': 'cloud',
  'E-Commerce': 'shop'
};

export const MENU_INTERNAL_ROUTES: Record<string, string> = {
  '7220714d-6c37-4724-a4c5-a48a046076b6': '/home',
  'f017e75e-2bfc-4158-8020-94c0c8fa93b2': '/credits/statement',
  // '729115fa-ffc4-403b-8fd3-427c10b68aad': '/finances/bank-reconciliation/summary',
}

export const MODAL_INTERNAL_ROUTES: Record<string, string> = {
  '/home': '/Home/Index',
  '/credits/statement': '/Sales/ClientStatements',
  // '/finances/bank-reconciliation': '/Finances/BankReconciliationDetails',
};
